import React from 'react';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import './ImageComponentBox.scss';
import { ASSET_URL } from '../../../../env/Configurations';

const ImageComponentBox = (props) => {
  const { componentObj, onClickComponent, componentNdx, isPreview, onClickRedirectLink } = props;

  const getImageAligin = (alignment) => {
    if (!alignment) return 'center';
    if (alignment === 'left') return 'start';
    if (alignment === 'center') return alignment;
    if (alignment === 'right') return 'end';
  };

  const onComponentClick = () => {
    componentObj.index = componentNdx;
    componentObj.selected = true;
    onClickComponent(componentObj, componentNdx);
  };

  return (
    <div
      className={`card layout-card image-box col-md-12 justify-content-center ${
        !isPreview && componentObj.selected ? 'layout-card-selected' : ''
      }`}
      onClick={() => onComponentClick()}
      style={{
        backgroundColor: componentObj?.hexCode || '#82828214',
      }}
    >
      {componentObj?.image ? (
        <img
          src={ASSET_URL + componentObj?.image}
          className='image-box-image'
          style={{
            alignSelf: getImageAligin(componentObj?.alignment),
            width: `${componentObj?.width}px` || '200px',
            height: `${componentObj?.height}px` || '200px',
            padding: componentObj?.padding
              ? `${componentObj?.top}px ${componentObj?.right}px ${componentObj?.bottom}px ${componentObj?.left}px`
              : 0,
          }}
          onClick={() => onClickRedirectLink(componentObj?.urlLink)}
        />
      ) : (
        <InsertPhotoIcon
          className='image-icon-body'
          style={{
            alignSelf: getImageAligin(componentObj?.alignment),
          }}
        />
      )}
    </div>
  );
};

export default ImageComponentBox;
